export default __webpack_public_path__ + "static/media/coaches.87f68e43.svg";